import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { commaFormatted } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import LaporanPersensiForm from './components/LaporanPersensiForm.component';


export default class LaporanPersensi extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this.state = {
      form: {
        value: {},
        error: {},
      },
    };
  }

  componentDidMount() {
    const { handleGetCodeOfAccount, location, handleGetClasses } = this.props;
    handleGetClasses();
  }

  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      files,
    } = event.target;
    const { inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      if (inputType === 'number') {
        formattedValue = commaFormatted(value);
      }
      if (inputType === 'file') {
        [formattedValue] = files;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            [name]: formattedValue,
          },
          error: {
            ...prevState.form.error,
            [name]: '',
          },
        },
      };
    });
  }

  _onClickNext() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/laporan/cetak-laporan-persensi');
  }

  render() {
    const { form } = this.state;
    return (
      <div className="student-list">
        <form onSubmit={this._onSubmit}>


          <LaporanPersensiForm
            form={form}
            onChange={this._onFormChange}
          />
          <div className="upload-student__content">
            <Button
              onClick={this._onClickNext}
              title="Submit"
            />
          </div>
        </form>
      </div>
    );
  }
}
LaporanPersensi.propTypes = {
  handleGetKlapper: PropTypes.func,
  handleDeleteKlapper: PropTypes.func,
  handleGetClasses: PropTypes.func,
};
LaporanPersensi.defaultProps = {
  handleGetKlapper: noop,
  handleDeleteKlapper: noop,
  handleGetClasses: noop,
};
